/**
 * Returns breadcrumb links for a given pathname.
 * Matches the logic used in Dashboard layout custom Breadcrumbs.
 * @param {string} pathname - Current route pathname
 * @returns {Array<{ title: string, to?: string }>}
 */
export function getBreadcrumbLinks(pathname) {
  const links = [{ title: 'Home', to: '/' }];

  // Order matters: more specific paths first
  if (pathname.includes('/users/permissions')) {
    return [...links, { title: 'Users', to: '/users' }, { title: 'Permissions' }];
  }
  if (pathname === '/users') {
    return [...links, { title: 'Users' }];
  }
  if (pathname === '/clients') {
    return [...links, { title: 'Clients' }];
  }
  if (pathname === '/divisions') {
    return [...links, { title: 'Clients', to: '/clients' }, { title: 'Divisions' }];
  }
  if (pathname === '/centres/splits') {
    return [...links, { title: 'Centres', to: '/centres' }, { title: 'GPSP Splits' }];
  }
  if (pathname === '/centres') {
    return [...links, { title: 'Centres' }];
  }
  if (pathname === '/dentists') {
    return [...links, { title: 'Centres', to: '/centres' }, { title: 'Dentists' }];
  }
  if (pathname === '/specialists') {
    return [...links, { title: 'Specialists' }];
  }
  if (pathname === '/emergency-dentists') {
    return [...links, { title: 'Emergency Dentists' }];
  }
  if (pathname === '/group-plans/expiring') {
    return [...links, { title: 'Group Plans', to: '/group-plans' }, { title: 'Expiring' }];
  }
  if (pathname.includes('/group-plans/coverage')) {
    return [...links, { title: 'Group Plans', to: '/group-plans' }, { title: 'Coverage' }];
  }
  if (pathname.includes('/group-plans/excluded-procedures')) {
    return [...links, { title: 'Group Plans', to: '/group-plans' }, { title: 'Excluded Procedures' }];
  }
  if (pathname.includes('/group-plans/benefit-years/')) {
    return [...links, { title: 'Group Plans', to: '/group-plans' }, { title: 'Benefit Years' }];
  }
  if (pathname === '/group-plans') {
    return [...links, { title: 'Group Plans' }];
  }
  if (pathname === '/fee-guides') {
    return [...links, { title: 'Fee Guides' }];
  }
  if (pathname === '/members/centre-transfer') {
    return [...links, { title: 'Members', to: '/members' }, { title: 'Centre Transfer' }];
  }
  if (pathname === '/members') {
    return [...links, { title: 'Members' }];
  }
  if (pathname === '/dependents' || pathname.startsWith('/dependents/')) {
    return [...links, { title: 'Members', to: '/members' }, { title: 'Dependents' }];
  }
  if (pathname === '/reports/members') {
    return [...links, { title: 'Reports', to: '/reports' }, { title: 'Member Reports' }];
  }
  if (pathname === '/reports/invoices') {
    return [...links, { title: 'Reports', to: '/reports' }, { title: 'Invoice Reports' }];
  }
  if (pathname === '/reports/claims') {
    return [...links, { title: 'Reports', to: '/reports' }, { title: 'Claim Reports' }];
  }
  if (pathname === '/reports/browser') {
    return [...links, { title: 'Reports', to: '/reports' }, { title: 'Report Browser' }];
  }
  if (pathname === '/reports/eligibility') {
    return [...links, { title: 'Reports', to: '/reports' }, { title: 'Eligibility' }];
  }
  if (pathname === '/reports/broker') {
    return [...links, { title: 'Reports', to: '/reports' }, { title: 'Broker' }];
  }
  if (pathname === '/reports/discrepancies') {
    return [...links, { title: 'Reports', to: '/reports' }, { title: 'Status discrepancies' }];
  }
  if (pathname === '/reports') {
    return [...links, { title: 'Reports' }];
  }
  if (pathname === '/claims/payment-schedule') {
    return [...links, { title: 'Claims', to: '/claims' }, { title: 'Payment Schedules' }];
  }
  if (pathname === '/claims' || pathname.startsWith('/claims/')) {
    return [...links, { title: 'Claims' }];
  }
  if (pathname === '/audit') {
    return [...links, { title: 'Audit' }];
  }
  if (pathname === '/emails-sent') {
    return [...links, { title: 'Emails Sent' }];
  }

  // Default: derive from menu (dashboard, brokers, carriers, payments, test-table)
  const menuMap = {
    '/': 'Dashboard',
    '/brokers': 'Brokers',
    '/carriers': 'Carriers',
    '/payments': 'Payments',
    '/test-table': 'Test Table'
  };
  const title = menuMap[pathname];
  if (title) {
    return pathname === '/' ? links : [...links, { title }];
  }

  // Fallback: show path segment as last crumb
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length > 0) {
    const last = segments[segments.length - 1];
    const display = last.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
    return [...links, { title: display }];
  }

  return links;
}
